import { render, staticRenderFns } from "./PlayerPage.vue?vue&type=template&id=24c13894&scoped=true"
import script from "./PlayerPage.vue?vue&type=script&lang=js"
export * from "./PlayerPage.vue?vue&type=script&lang=js"
import style0 from "./PlayerPage.vue?vue&type=style&index=0&id=24c13894&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c13894",
  null
  
)

export default component.exports